import {
  BlogPostI,
  CustomerSuccessStoryI,
} from "@/interfaces/strapi/collection-types";
import { MetaI } from "@/interfaces/meta";
import { getStrapiImageURL } from "@/helpers/strapi";

export const getArticleMetaTags = (
  article: CustomerSuccessStoryI | BlogPostI | undefined
): MetaI => {
  if (!article) {
    return {};
  }

  // article - Namespace URI: https://ogp.me/ns/article#

  // article:published_time - datetime - When the article was first published.
  // article:modified_time - datetime - When the article was last changed.
  // article:expiration_time - datetime - When the article is out of date after.
  // article:author - profile array - Writers of the article.
  // article:section - string - A high-level section name. E.g. Technology
  // article:tag - string array - Tag words associated with this article.

  return {
    title: article?.meta_title || article?.headline,
    description: article?.meta_description || article?.subheadline,
    openGraph: {
      type: "article",
      images: article?.meta_og_img
        ? [
            {
              url: getStrapiImageURL(article.meta_og_img) as string,
              width: 1200,
              height: 630,
              alt:
                article.meta_og_img.data?.attributes?.caption ||
                article.headline ||
                "Article Image",
            },
          ]
        : undefined,

      article: {
        publishedTime: article?.publishedAt,
        modifiedTime: article?.updatedAt,
        authors: [article?.credits as string],
        section: "Cold Calling",
        tags: article?.tags?.map(({ value }) => value) || [
          "Sales",
          "Cold Calling",
          "Outbound",
        ],
      },
    },
    twitter: {
      title: article?.meta_title || article?.headline,
      description: article?.meta_description || article?.subheadline,
      image: article?.meta_twitter_img
        ? (getStrapiImageURL(article.meta_twitter_img) as string)
        : undefined,
    },
  };
};
